<div class="contenedorInt">
    <div class="contenedorIntHeader">
        <header class="FheaderInt FhInt" id="HlicitacionesInt">
            <div class="textHeader flx">
                <div class="dUno dmMedio"></div>
                <div class="dSeis dtOcho dmOnce">
                    <h1>RESTABLECIMIENTO DE CONTRASEÑA</h1>
                    <p class="mt-3">
						Ingresa tu nueva contraseña, esta remplazara la anterior.
                    </p>
                </div>
                <div class="dCinco dtDos dmMedio"></div>
            </div>
        </header>
	</div>

    <div class="FformContacto dDiez dtDiez dmOnce mt-3 mb-5">
        <nav class="navbar navbar-expand navbar-light">
            <div id="navLicitaciones" class="collapse navbar-collapse d-flex flex-row-reverse">
                <ul class="navbar-nav row">
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/listado-ofertas']" class="nav-link m-1">Listado de ofertas</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/listado-proveedor']" class="nav-link m-1">Mis postulaciones</a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/actualizacion-registro']" class="nav-link m-1"> Actualizar registro </a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/actualizacion-contrasena']" class="nav-link m-1 disabled" tabindex="-1" aria-disabled="true"> Actualizar Contraseña </a>
                    </li>
                    <li class="nav-item">
                        <a [routerLink]="['/licitaciones/login']" class="nav-link cerrar m-1 redBtn">Cerrar sesión</a>
                    </li>
                </ul>
            </div>
        </nav>
        <h3 class="mt-5 mb-3">RESTABLECE TU CONTRASEÑA</h3>
		<div class="row">
			<div class="col-12 mt-3">
                <form #f="ngForm" (ngSubmit)="onSubmit(f)" ngNativeValidate class="pb-3 text-left">
                    <div class="row">
                        <div class="form-group mb-3 col-lg-6 col-md-6 text-left">
                            <label for="nuevaContrasena">Nueva contraseña</label>
                            <div class="input-group">
                                <input ngModel name="password" id="nuevaContrasena" required class="form-control flat" type="password" [type]="fieldTextType ? 'text' : 'password'">
                                <div class="input-group-prepend">
									<span class="input-group-text">
										<div class="iconoForm" [ngClass]="{
											'icono-eyeNo': !fieldTextType,
											'icono-eye': fieldTextType
											}" (click)="toggleFieldTextType()">
										</div>
									</span>
								</div>
                            </div>
                        </div>
                        <div class="form-group mb-3 col-lg-6 col-md-6 text-left">
                            <label for="confirmaNuevaContrasena">Confirma nueva contraseña</label>
                            <div class="input-group">
                                <input ngModel name="confirmaNuevaContrasena" id="confirmaNuevaContrasena" required class="form-control flat" type="password" [type]="fieldTextType2 ? 'text' : 'password'">
                                <div class="input-group-prepend">
									<span class="input-group-text">
										<div class="iconoForm" [ngClass]="{
											'icono-eyeNo': !fieldTextType2,
											'icono-eye': fieldTextType2
											}" (click)="toggleFieldTextType2()">
										</div>
									</span>
								</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12 text-center mt-3 mb-2">
                        <button type="submit" class="btn-enviar pl-5 pr-5 mt-2">Actualizar</button>
                    </div>
                </form>
			</div>
		</div>

        <div class="alerta-exito blqCtr text-center" *ngIf="this.success">
            <img class="ico-confirmar" src="./../../../../assets/images/icons/icono-exito.png">
            <p>Información <strong>actualizada</strong> correctamente</p>
            <button class="btn-confirmar" (click)="closeok()">Aceptar</button>
        </div>
        <div class="alerta-exito blqCtr text-center" *ngIf="this.fail">
            <img class="contrasenas" src="./../../../../assets/images/icons/icono-pass-diferentes.jpg">
            <p>Confirme que las <strong>contraseñas</strong> sean <strong>identicas</strong></p>
            <button class="btn-confirmar" (click)="cancel()">Aceptar</button>
        </div>
	</div>

</div>